// Division standings tables as Classic's StandingsTable input (#583, #710),
// shared by Schedule's stacked standings and Home's.
import type { FeaturedItem } from '@/services/api'
import type { DivisionStandingsTable } from '../../../core/data/useDivisionStandings'

export function seasonLabel(season: DivisionStandingsTable['season']): string | null {
  if (!season) return null
  return season.name ?? String(season.year)
}

export function asFeatured(table: DivisionStandingsTable, limit: number | null): FeaturedItem {
  return {
    id: table.division.id,
    type: 'season',
    contentId: table.season?.id ?? 0,
    name: table.division.name,
    year: table.season?.year ?? 0,
    displayOrder: 0,
    standings: (limit == null ? table.rows : table.rows.slice(0, limit)).map((r) => r.raw),
    // The season's strategy columns (win % adds PCT, #651).
    ...(table.rankingStrategy ? { rankingStrategy: table.rankingStrategy } : {}),
  }
}
